export default function getGreetings() {
  const currentTime = new Date();
  const currentHour = currentTime.getHours();
  let greetingMessage;
  if (currentHour >= 5 && currentHour < 12) {
    greetingMessage = "morning";
  } else if (currentHour >= 12 && currentHour < 17) {
    greetingMessage = "afternoon";
  } else {
    greetingMessage = "evening";
  }
  return greetingMessage;
}
